import React, {useEffect, useState} from "react";
import {Alert, Box, Snackbar} from "@mui/material";
import ResolvedModal from "./components/resolvedModal";
import ResolvedDrawer from "./components/resolvedDrawer";
import {useNavigate, useParams, useSearchParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState} from "@store/store.tsx";
import {
    fetchTicketDetailsById,
    updateTicketStatus,
} from "@store/ticketListSlice.tsx";
import AddUserModal from "@common/components/AddUser/addUserModal";
import {clearMessages, clearUploadStatus, fetchMessages, setAttachments} from "@store/chatSlice.tsx";
import Conversation from "./components/conversation";
import ChatInputSection from "./components/chatInputSection";
import ChatHeader from "./components/chatHeader";

const Chat: React.FC = () => {
    const [resolvedDrawer, setResolvedDrawer] = useState<boolean>(false);
    const [addUserModal, setAddUserModal] = useState<boolean>(false);
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const {id} = useParams();
    const [initialLoader, setInitialLoader] = useState(true);
    const [customStatus, setCustomStatus] = useState<string>("");
    const {ticketDetails} = useSelector((state: RootState) => state.tickets);
    const {customStatuses} = useSelector((state: RootState) => state.config);
    const {uploadError} = useSelector((state: any) => state.chat)
    const currentTicketId = ticketDetails?.request?.id;

    const [searchParams] = useSearchParams();
    const status = searchParams.get("status");

    useEffect(() => {
        if (id && id !== "new") {
            dispatch(fetchMessages({ticketId: Number(id), page: 1}));
        } else {
            dispatch(clearMessages());
        }
        dispatch(setAttachments([]));
    }, []);
    useEffect(() => {
        if (id && id !== "new") {
            (async () => {
                const resultAction = await dispatch(fetchTicketDetailsById({id}));
                const success = fetchTicketDetailsById.fulfilled.match(resultAction);
                if (!success) {
                    navigate("/");
                }
            })()

        }
    }, [id]);
    const handleTicketResolvedAction = () => {
        if (ticketDetails?.request) {
            let tags: string = "";
            if (ticketDetails?.request?.subject === "LIVE PERFUSION") {
                tags = "live_perfusion";
            }
            if (ticketDetails?.request?.subject === "POST PERFUSION") {
                tags = "post_perfusion";
            }
            if (ticketDetails?.request?.subject === "GENERAL") {
                tags = "general";
            }
            const customStatus = customStatuses.find((status) => status.endUserLabel === "Resolved");
            let tagValue = "general";
            if (tags?.includes("live_perfusion")) {
                tagValue = "live_perfusion";
            } else if (ticketDetails.request.subject.includes("post_perfusion")) {
                tagValue = "post_perfusion";
            }

            const payload = {
                customTicketStatusId: customStatus?.id,
                tag: tagValue,
                statusName: "solved",
            };
            dispatch(
                updateTicketStatus({
                    ticketId: ticketDetails?.request?.id,
                    payload,
                })
            );
            setResolvedDrawer(false);
        }
    };

    const handleBackClick = () => {
        if (status) {
            navigate(-1);
        } else {
            navigate("/");
        }
    };

    return (
        <>
            <ChatHeader
                ticketId={id}
                onBackClick={handleBackClick}
                setResolvedDrawer={setResolvedDrawer}
                status={status}
                setCustomStatus={setCustomStatus}
                customStatus={customStatus}
                id={id}/>
            <Box
                className="md:px-8"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "calc(100vh - 213px)",
                    justifyContent: "space-between",
                }}
            >
                <Conversation
                    setInitialLoader={setInitialLoader}
                    initialLoader={initialLoader}
                />{status !== "closed" && (
                <ChatInputSection setAddUserModal={setAddUserModal} customStatus={customStatus}/>)}
                <ResolvedModal
                    resolvedDrawer={resolvedDrawer}
                    setResolvedDrawer={setResolvedDrawer}
                    handleTicketResolvedAction={handleTicketResolvedAction}
                />
                <ResolvedDrawer
                    resolvedDrawer={resolvedDrawer}
                    setResolvedDrawer={setResolvedDrawer}
                    handleTicketResolvedAction={handleTicketResolvedAction}
                />
                <AddUserModal
                    addUserModal={addUserModal}
                    setAddUserModal={setAddUserModal}
                    ticketId={currentTicketId}      // Pass the ticket ID
                />
            </Box>
            <Snackbar
                className="!pt-[8rem] md:!pt-14"
                open={!!uploadError}
                autoHideDuration={3000}
                onClose={() => dispatch(clearUploadStatus())}
                anchorOrigin={{vertical: "top", horizontal: "center"}}
            >
                <Alert variant="filled" severity="error">
                    {uploadError}
                </Alert>
            </Snackbar>
        </>
    );
};
export default Chat;